import { default_header, default_header_example } from '../defaultData';
import { apiParamDesc, apiDocDesc } from '../docHelpers';

// 쿠팡(B378) 필수옵션/필수그룹옵션 객체 공통 필드 (opt_yn=true 시 응답에 포함)
const cpangOptAttrFields = [
  { title: 'attributeTypeName', required: '', type: 'String', desc: '옵션타입명', indent: 3 },
  {
    title: 'dataType',
    required: '',
    type: 'String',
    desc: apiParamDesc({ title: '데이터형식', allowedValues: [['STRING', '문자열'], ['NUMBER', '숫자'], ['DATE', '날짜']] }),
    indent: 3,
  },
  { title: 'basicUnit', required: '', type: 'String', desc: '기본단위', indent: 3 },
  { title: 'usableUnits', required: '', type: 'String[]', desc: '사용 가능한 단위값 목록', indent: 3 },
  {
    title: 'inputType',
    required: '',
    type: 'String',
    desc: apiParamDesc({ title: '입력방식', allowedValues: [['INPUT', '직접입력'], ['SELECT', '선택']] }),
    indent: 3,
  },
  { title: 'inputValues', required: '', type: 'String[]', desc: 'inputType 이 SELECT 인 경우 선택 가능한 값 목록', indent: 3 },
  {
    title: 'required',
    required: '',
    type: 'String',
    desc: apiParamDesc({ title: '필수 여부', allowedValues: [['MANDATORY', '필수'], ['OPTIONAL', '선택']] }),
    indent: 3,
  },
  {
    title: 'groupNumber',
    required: '',
    type: 'String',
    desc: apiParamDesc({ title: '그룹속성값', sub: 'NONE: 그룹 아님 / 1·2: 동일 번호끼리 택1 그룹' }),
    indent: 3,
  },
  {
    title: 'exposed',
    required: '',
    type: 'String',
    desc: apiParamDesc({ title: '구매옵션/검색옵션 구분', allowedValues: [['EXPOSED', '구매옵션'], ['NONE', '검색옵션']] }),
    indent: 3,
  },
];

const getV10APIs = (userInfo) => {
  return [
    {
      title: '머리말 꼬리말 조회',
      url: '/doc/머리말 꼬리말 조회',
      data: [
        {
          version: 'v1.0',
          url: '/addcontents',
          desc: '사용중인 솔루션에 등록된 머리말꼬리말 목록을 조회합니다.',
          method: 'POST',
          unrecognized_aff_no: [1057],
          header: default_header,
          header_example: default_header_example,
          body: [
            {
              title: 'search_key',
              required: '',
              type: 'String',
              desc: apiParamDesc({
                title: '검색조건',
                allowedValues: [
                  ['addcontent_no', '<strong>템플릿코드</strong>'],
                  ['addcontent_name', '<strong>머리말/꼬리말 템플릿명</strong>'],
                ],
                notes: ['<code>값을 넣지않는경우 전체검색됩니다.</code>'],
              }),
            },
            {
              title: 'search_word',
              required: '',
              type: 'String',
              desc: '검색어',
            },
            {
              title: 'addcontentTarget',
              required: '',
              type: 'String',
              desc: apiParamDesc({
                title: '템플릿 종류',
                allowedValues: [['상품명', '<strong>상품명</strong>'], ['상세설명', '<strong>상세설명</strong>']],
                notes: ['<code>값을 넣지않는경우 전체검색됩니다.</code>'],
              }),
            },
            {
              title: 'addcontentType',
              required: '',
              type: 'String',
              desc: apiParamDesc({
                title: '템플릿 유형',
                allowedValues: [
                  ['공지사항', '<strong>공지사항</strong>'],
                  ['베송지연', '<strong>베송지연</strong>'],
                  ['이벤트', '<strong>이벤트</strong>'],
                  ['기타', '<strong>기타</strong>'],
                ],
                notes: ['<code>값을 넣지않는경우 전체검색됩니다.</code>'],
              }),
            },
            {
              title: 'viewPosition',
              required: '',
              type: 'String',
              desc: apiParamDesc({
                title: '템플릿 유형',
                allowedValues: [['머리말', '<strong>머리말</strong>'], ['꼬리말', '<strong>꼬리말</strong>']],
                notes: ['<code>값을 넣지않는경우 전체검색됩니다.</code>'],
              }),
            },
          ],
          body_example: {
            search_key: '',
            search_word: '',
            addcontentTarget: '상세설명',
            addcontentType: '이벤트',
            viewPosition: '',
          },
          response: [
            {
              title: 'addcontent_no',
              required: 'O',
              type: 'Number',
              desc: '템플릿 코드',
            },
            {
              title: 'addcontentTarget',
              required: 'O',
              type: 'String',
              desc: '템플릿 종류',
            },
            {
              title: 'addcontent_type',
              required: 'O',
              type: 'String',
              desc: '템플릿 유형',
            },
            {
              title: 'wdate',
              required: 'O',
              type: 'String',
              desc: '등록일',
            },
            {
              title: 'mdate',
              required: 'O',
              type: 'String',
              desc: '수정일',
            },
            {
              title: 'addcontent_name',
              required: 'O',
              type: 'String',
              desc: '머리말꼬리말 템플릿명',
            },
            {
              title: 'header_content',
              required: 'O',
              type: 'String',
              desc: '머리말',
            },
            {
              title: 'footer_content',
              required: 'O',
              type: 'String',
              desc: '꼬리말',
            },
            {
              title: 'apply_cnt',
              required: 'O',
              type: 'String',
              desc: '적용상품 수',
            },
          ],
          response_example: {
            results: [
              {
                addcontent_no: 1561,
                addcontentTarget: '상세설명',
                addcontent_type: '이벤트',
                wdate: '2020-10-05 18:25:38',
                mdate: '2020-10-05 18:25:38',
                addcontent_name: '이벤트',
                header_content: '',
                footer_content: 'event!',
                apply_cnt: 0,
              },
            ],
          },
        },
      ],
    },
    {
      title: '온라인상품 판매수량 수정',
      url: '/doc/온라인상품 판매수량 수정',
      data: [
        {
          version: 'v1.0',
          url: '/products/sale-cnt',
          desc: apiDocDesc({
            items: ['온라인상품의 쇼핑몰판매수량 및 등록된 옵션정보의 판매수량을 수정합니다.', '옵션 판매수량 수정시 sku 정보가 매칭된 옵션만 수정가능합니다.'],
          }),
          method: 'PATCH',
          unrecognized_aff_no: [1057],
          header: default_header,
          header_example: default_header_example,
          body: [
            {
              title: 'products',
              required: 'O',
              type: 'Array',
              desc: '상품정보',
            },
            {
              title: 'c_sale_cd',
              required: 'O',
              type: 'String',
              desc: '판매자관리코드',
              indent: 1,
            },
            {
              title: 'shop_cd',
              required: 'O',
              type: 'String',
              desc: '쇼핑몰코드',
              indent: 1,
            },
            {
              title: 'shop_id',
              required: 'O',
              type: 'String',
              desc: '쇼핑몰아이디',
              indent: 1,
            },
            {
              title: 'std_ol_yn',
              required: '',
              type: '',
              desc: apiParamDesc({
                title: '단일상품여부',
                defaultValue: 'N',
                allowedValues: [['Y', '단일상품'], ['N', '일반상품']],
              }),
              indent: 1,
            },
            {
              title: 'sale_cnt_limit',
              required: '',
              type: 'Number',
              desc: apiParamDesc({ title: '쇼핑몰판매수량', sub: '(상품정보)' }),
              indent: 1,
            },
            {
              title: 'opts',
              required: 'O',
              type: 'Array',
              desc: '상품 옵션정보',
              indent: 1,
            },
            {
              title: 'type',
              required: 'O',
              type: 'String',
              desc: apiParamDesc({
                title: '옵션 구분',
                allowedValues: [['general', '일반옵션'], ['additional', '추가구매옵션']],
              }),
              indent: 2,
            },
            {
              title: 'sku_cd',
              required: 'O',
              type: 'String',
              desc: 'SKU코드',
              indent: 2,
            },
            {
              title: 'stock_cnt',
              required: 'O',
              type: 'Number',
              desc: '옵션판매수량',
              indent: 2,
            },
            {
              title: 'status',
              required: 'O',
              type: 'String',
              desc: apiParamDesc({ title: '옵션 상태', allowedValues: ['정상', '품절'] }),
              indent: 2,
            },
          ],
          body_example: {
            products: [
              {
                c_sale_cd: 'm202212095bb6ecdb5',
                shop_cd: 'A001',
                shop_id: 'myshopy3',
                std_ol_yn: 'N',
                opts: [
                  {
                    type: 'general',
                    sku_cd: 'S186F46BD14F',
                    stock_cnt: 10,
                    status: '정상',
                  },
                  {
                    type: 'additional',
                    sku_cd: 'S52590348AD7',
                    stock_cnt: 33,
                    status: '정상',
                  },
                ],
              },
            ],
          },
          response: [
            {
              title: 'c_sale_cd',
              required: 'O',
              type: 'String',
              desc: '판매자 관리코드',
            },
            {
              title: 'shop_cd',
              required: 'O',
              type: 'String',
              desc: '쇼핑몰코드',
            },
            {
              title: 'shop_id',
              required: 'O',
              type: 'String',
              desc: '쇼핑몰아이디',
            },
            {
              title: 'std_ol_yn',
              required: 'O',
              type: 'String',
              desc: '단일상품여부',
            },
            {
              title: 'result',
              required: 'O',
              type: 'String',
              desc: apiParamDesc({ title: '성공 또는 실패', allowedValues: ['성공', '실패'] }),
            },
            {
              title: 'message',
              required: 'O',
              type: 'String',
              desc: '실패시 에러메세지',
            },
          ],
          response_example: [
            {
              c_sale_cd: 'm202212095bb6ecdb5',
              shop_cd: 'A001',
              shop_id: 'myshopy3',
              std_ol_yn: 'N',
              result: '성공',
              message: '',
            },
          ],
        },
      ],
    },
    {
      title: '온라인상품 연동 수정/해제',
      url: '/doc/온라인상품 연동 수정',
      data: [
        {
          version: 'v1.0',
          url: '/products/setShopLinkInfo',
          method: 'PATCH',
          unrecognized_aff_no: [1057],
          desc: apiDocDesc({
            items: [
              '온라인 상품의 쇼핑몰 상품코드를 직접 입력하여 쇼핑몰 연동 정보를 변경합니다.',
              '온라인상품에 해당 쇼핑몰의 판매중인 상품번호 또는 상품코드를 입력합니다.',
              '<div style="color: red">솔루션의 상태만 변경되고 실제 쇼핑몰의 상태는 변경되지 않습니다.</div>',
            ],
          }),
          header: default_header,
          header_example: default_header_example,
          body: [
            {
              title: 'type',
              required: 'O',
              type: 'string',
              desc: apiParamDesc({
                title: '연동 방식 선택',
                allowedValues: [['edit', '연동 수정'], ['stop', '연동 해제']],
                notes: [
                  'edit: 연동 수정 (쇼핑몰 상품 코드를 입력하며 해당 상품의 상태를 판매중으로 변경)',
                  'stop: 연동 해제 (쇼핑몰 상품 코드를 삭제하며 해당 상품의 상태를 판매대기로 변경)',
                ],
              }),
            },
            {
              title: 'sale_data',
              required: 'O',
              type: 'Object[]',
              desc: '연동할 상품 데이터'
            },
            ...(userInfo.sol_no === 104083 ? [{
              title: 'sub_sol_no',
              required: '',
              type: 'Number',
              desc: apiParamDesc({
                title: '하위계정 sol_no',
                sub: '<span style="color: red">* 하위 계정 상품을 연동 수정할 경우 에픽카(쇼핑몰)만 수정 가능합니다.</span>',
              }),
              indent: 1
            }] : []),
            {
              title: 'c_sale_cd',
              required: 'O',
              type: 'String',
              desc: '판매자 관리코드',
              indent: 1
            },
            {
              title: 'shop_cd',
              required: 'O',
              type: 'String',
              desc: '쇼핑몰 코드',
              indent: 1
            },
            {
              title: 'shop_id',
              required: 'O',
              type: 'String',
              desc: '쇼핑몰 ID',
              indent: 1
            },
            {
              title: 'shop_sale_no',
              required: 'O',
              type: 'String',
              desc: '연동할 쇼핑물 상품코드',
              indent: 1
            }
          ],
          body_example: {
            type: 'edit',
            sale_data: [
              {
                c_sale_cd: 'm202212095bb6ecdb5',
                shop_cd: 'A001',
                shop_id: 'myshopy3',
                shop_sale_no: '12345678'
              },
              {
                c_sale_cd: 'm202212095bb6ecdb5',
                shop_cd: 'A006',
                shop_id: 'myshopy2',
                shop_sale_no: '1234567851525'
              }
            ],
          },
          response: [
            {
              title: 'results',
              required: 'O',
              type: 'Object[]',
              desc: '결과값',
            },
            {
              title: 'success',
              required: '',
              type: 'Number',
              desc: '연동 수정/해제 성공 수\n(성공할 경우에만 존재)',
              indent: 1
            },
            {
              title: 'error',
              required: '',
              type: 'Number',
              desc: '연동 수정/해제 실패 수\n(실패할 경우에만 존재)',
              indent: 1
            },
            {
              title: 'duplicates',
              required: '',
              type: 'Number',
              desc: '입력한 쇼핑몰 상품코드 중 이미 존재하는 쇼핑몰 상품코드 수\n(상품이 중복될 경우에만 존재)',
              indent: 1
            },
            {
              title: 'values',
              required: '',
              type: 'String[]',
              desc: '중복된 쇼핑몰 상품코드 리스트\n(상품이 중복될 경우에만 존재)',
              indent: 1
            },
          ],
          response_example: [
            {
              results: [
                {
                  success: 2,
                  error:2,
                  duplicates:2,
                  values: []
                }
              ]
            }
          ],
        },
      ],
    },
    {
      title: '카테고리 조회',
      url: '/doc/카테고리 조회',
      data: [
        {
          version: 'v1.0',
          url: '/categorys',
          desc: '사용중인 솔루션에 등록된 카테고리 목록을 조회합니다.',
          method: 'GET',
          unrecognized_aff_no: [1057],
          header: default_header,
          header_example: default_header_example,
          query: [
            {
              title: 'start',
              required: '',
              type: 'Number',
              desc: '검색 시작 값',
            },
            {
              title: 'length',
              required: '',
              type: 'Number',
              desc: apiParamDesc({
                title: '조회할 카테고리 갯수',
                sub: '최대 1,000건 단위로 검색 가능하며 미입력 시 전체 조회됩니다.',
                maxValue: '1000',
              }),
            },
            {
              title: 'opt_yn',
              required: '',
              type: 'String',
              desc: apiParamDesc({
                title: '필수옵션 전달 여부',
                sub: "'true' 전달 시, 쿠팡(B378) 매칭 카테고리에 한해 응답에 필수옵션/필수그룹옵션 정보가 추가됩니다. (현재 쿠팡만 지원, 미입력 시 미포함)",
                allowedValues: [['true', '필수옵션/필수그룹옵션 포함'], ['false', '미포함 (기본값)']],
              }),
            },
          ],
          response: [
            {
              title: 'group',
              required: 'O',
              type: 'String',
              desc: '카테고리 분류',
            },
            {
              title: 'category_info',
              required: 'O',
              type: 'Array',
              desc: '해당 분류에 설정된 카테고리 정보',
            },
            {
              title: 'cate_no',
              required: 'O',
              type: 'Number',
              desc: '카테고리코드',
              indent: 1,
            },
            {
              title: 'category_name',
              required: 'O',
              type: 'String',
              desc: '설정된 카테고리',
              indent: 1,
            },
            {
              title: 'matched_site_category',
              required: 'O',
              type: 'Array',
              desc: '해당 카테고리정보에 매칭된 쇼핑몰 카테고리 정보',
              indent: 1,
            },
            {
              title: 'shop_name',
              required: 'O',
              type: 'String',
              desc: '쇼핑몰 이름',
              indent: 2,
            },
            {
              title: 'shop_id',
              required: 'O',
              type: 'String',
              desc: '쇼핑몰 아이디',
              indent: 2,
            },
            {
              title: 'shop_cate',
              required: 'O',
              type: 'String',
              desc: '해당 쇼핑몰에 매칭된 카테고리',
              indent: 2,
            },
            {
              title: 'has_required_opt',
              required: '',
              type: 'Boolean',
              desc: 'opt_yn=true 이고 쿠팡(B378)인 경우에만 포함. 필수옵션 존재 여부',
              indent: 2,
            },
            {
              title: 'required_opt_list',
              required: '',
              type: 'Object[]',
              desc: '필수옵션 목록 (각 옵션을 개별 입력)',
              indent: 2,
            },
            ...cpangOptAttrFields,
            {
              title: 'has_group_opt',
              required: '',
              type: 'Boolean',
              desc: '필수그룹옵션 존재 여부',
              indent: 2,
            },
            {
              title: 'group_opt_list',
              required: '',
              type: 'Object[][]',
              desc: '필수그룹옵션 목록. 그룹별 배열로 묶이며 각 그룹에서 1개만 입력 (요소 객체 구조는 required_opt_list 와 동일)',
              indent: 2,
            },
            ...cpangOptAttrFields,
          ],
          response_example: [
            {
              group: '테스트 카테고리',
              category_info: [
                {
                  cate_no: 103592,
                  category_name: '여성의류 > 가디건 > 라운드/U넥가디건',
                  matched_site_category: [
                    {
                      shop_name: '11번가',
                      shop_id: 'playauto',
                      shop_cate: '여성의류 > 가디건 > 기본 가디건',
                    },
                    {
                      shop_name: '지마켓',
                      shop_id: 'playauto',
                      shop_cate: '여성의류 > 가디건 > 롱가디건',
                    },
                    {
                      shop_name: '쿠팡',
                      shop_id: 'playauto',
                      shop_cate: '패션의류 > 여성패션 > 가디건',
                      has_required_opt: true,
                      required_opt_list: [
                        {
                          attributeTypeName: '색상',
                          dataType: 'STRING',
                          basicUnit: '없음',
                          usableUnits: [],
                          inputType: 'INPUT',
                          inputValues: [],
                          required: 'MANDATORY',
                          groupNumber: 'NONE',
                          exposed: 'EXPOSED',
                        },
                        {
                          attributeTypeName: '소재',
                          dataType: 'STRING',
                          basicUnit: '없음',
                          usableUnits: [],
                          inputType: 'SELECT',
                          inputValues: ['면', '울', '폴리에스터', '혼방'],
                          required: 'MANDATORY',
                          groupNumber: 'NONE',
                          exposed: 'EXPOSED',
                        },
                      ],
                      has_group_opt: true,
                      group_opt_list: [
                        [
                          {
                            attributeTypeName: '가슴단면',
                            dataType: 'NUMBER',
                            basicUnit: 'cm',
                            usableUnits: ['cm', 'mm'],
                            inputType: 'INPUT',
                            inputValues: [],
                            required: 'MANDATORY',
                            groupNumber: '1',
                            exposed: 'EXPOSED',
                          },
                          {
                            attributeTypeName: '가슴둘레',
                            dataType: 'NUMBER',
                            basicUnit: 'cm',
                            usableUnits: ['cm', 'mm'],
                            inputType: 'INPUT',
                            inputValues: [],
                            required: 'MANDATORY',
                            groupNumber: '1',
                            exposed: 'EXPOSED',
                          },
                        ],
                      ],
                    },
                    '...',
                  ],
                },
              ],
            },
            '......',
          ],
        },
      ],
    },
    {
      title: '템플릿 조회',
      url: '/doc/템플릿 조회',
      data: [
        {
          version: 'v1.0',
          url: '/templates/?masking_yn=masking_yn',
          desc: '사용중인 솔루션에 등록된 템플릿 목록을 조회합니다.',
          method: 'GET',
          unrecognized_aff_no: [1057],
          header: default_header,
          header_example: default_header_example,
          body: [
            {
              title: 'masking_yn',
              required: '',
              type: 'Boolean',
              desc: apiParamDesc({ title: '개인정보 마스킹 처리 여부', defaultValue: 'false' }),
            },
          ],
          response: [
            {
              title: 'shop_cd',
              required: 'O',
              type: 'String',
              desc: '사이트코드',
            },
            {
              title: 'shop_name',
              required: 'O',
              type: 'String',
              desc: '사이트명',
            },
            {
              title: 'shop_id',
              required: 'O',
              type: 'String',
              desc: '사이트아이디',
            },
            {
              title: 'template_info',
              required: 'O',
              type: 'Array',
              desc: '템플릿 정보',
            },
            {
              title: 'template_no',
              required: 'O',
              type: 'Number',
              desc: '템플릿코드',
              indent: 1,
            },
            {
              title: 'wdate',
              required: 'O',
              type: 'String',
              desc: '템플릿 등록일',
              indent: 1,
            },
            {
              title: 'mdate',
              required: 'O',
              type: 'String',
              desc: '템플릿 수정일',
              indent: 1,
            },
            {
              title: 'name',
              required: 'O',
              type: 'String',
              desc: '템플릿 이름',
              indent: 1,
            },
            {
              title: 'apply_prod_cnt',
              required: 'O',
              type: 'Number',
              desc: '템플릿이 적용되어있는 온라인 상품 수',
              indent: 1,
            },
            {
              title: 'register_name',
              required: 'O',
              type: 'String',
              desc: '등록자',
              indent: 1,
            },
          ],
          response_example: [
            {
              shop_cd: 'A112',
              shop_name: '11번가',
              shop_id: 'playauto',
              template_info: [
                {
                  template_no: 41538,
                  wdate: '2018-08-31 14:36:07',
                  mdate: '2019-08-05 16:04:12',
                  name: '테스트 템플릿',
                  apply_prod_cnt: 3,
                  register_name: '김바보',
                },
              ],
            },
          ],
        },
      ],
    },
    {
      title: '쇼핑몰 상품 상태 변경',
      url: '/doc/쇼핑몰 상품 상태 변경',
      data: [
        {
          version: 'v1.0',
          url: '/products/setState',
          method: 'PATCH',
          unrecognized_aff_no: [1057],
          authorized_m_no: [181578],
          desc: apiDocDesc({
            items: [
              '하위 부품사의 [승인대기] 상태인 에픽카 쇼핑몰의 상품을 판매중으로 변경합니다.',
              '하위 부품사의 온라인상품코드를 통하여 상품 상태를 변경합니다.',
              '<div style="color: red">에픽카 쇼핑몰인 [승인대기] 상태의 상품인 경우에만 가능합니다.</div>',
            ],
          }),
          header: default_header,
          header_example: default_header_example,
          body: [
            {
              title: 'sale_data',
              required: 'O',
              type: 'Object[]',
              desc: '연동할 상품 데이터'
            },
            {
              title: 'sub_sol_no',
              required: '',
              type: 'Number',
              desc: apiParamDesc({ title: '하위계정 sol_no' }),
              indent: 1
            },
            {
              title: 'shop_cd',
              required: 'O',
              type: 'String',
              desc: apiParamDesc({
                title: '쇼핑몰 코드',
                sub: '<span style="color: red">* 에픽카(쇼핑몰)만 수정 가능합니다.</span>',
              }),
              indent: 1
            },
            {
              title: 'shop_id',
              required: 'O',
              type: 'String',
              desc: '쇼핑몰 ID',
              indent: 1
            },
            {
              title: 'shop_sale_no',
              required: 'O',
              type: 'String',
              desc: '수정할 상품의 쇼핑물 상품코드',
              indent: 1
            }
          ],
          body_example: {
            sale_data:[
              {
                sub_sol_no: 103419,
                shop_cd:"P051",
                shop_id:"test",
                shop_sale_no:"424242"
              },
              {
                sub_sol_no: 103419,
                shop_cd:"P051",
                shop_id:"test",
                shop_sale_no:"!!23112344"
              }
            ]

          },
          response: [
            {
              title: 'results',
              required: 'O',
              type: 'Object[]',
              desc: '결과값',
            },
            {
              title: 'status',
              required: '',
              type: 'String',
              desc: '해당 쇼핑몰 상품 상태 업데이트 성공/실패 여부',
              indent: 1
            },
            {
              title: 'shop_sale_no',
              required: '',
              type: 'String',
              desc: '해당 쇼핑몰 상품 번호',
              indent: 1
            },
            {
              title: 'message',
              required: '',
              type: 'String',
              desc: '판매중 상태 변경 실패한 경우 메세지',
              indent: 1
            },
          ],
          response_example: [
            {
              results: [
                {
                  status: 'error',
                  shop_sale_no: '424242',
                  message: "[승인대기] 이외의 상태는 변경할 수 없습니다."
                },
                {
                  status: "success",
                  shop_sale_no: "!!23112344"
                }
              ]
            }
          ],
        },
      ],
    },
    {
      title: '수집 상품 리스트 조회',
      url: '/doc/수집 상품 리스트 조회',
      data: [
        {
          version: 'v1.0',
          url: '/product/online/listOfScrap',
          desc: apiDocDesc({ items: ['상품 수집 작업을 통해 수집한 상품을 조회합니다.'] }),
          method: 'GET',
          header: default_header,
          header_example: default_header_example,
          query: [
            {
              title: 'shop_cd',
              required: '',
              type: 'String',
              desc: apiParamDesc({
                title: '쇼핑몰코드',
                sub: '( 옥션: A001, 지마켓: A006, 11번가: A112, 바이즐: A027... )',
              }),
            },
            {
              title: 'shop_id',
              required: '',
              type: 'String',
              desc: '쇼핑몰아이디',
            },
            {
              title: 'start',
              required: '',
              type: 'Number',
              desc: '검색 시작 값',
            },
            {
              title: 'length',
              required: '',
              type: 'Number',
              desc: apiParamDesc({
                title: '조회할 상품 갯수',
                maxValue: '300',
                defaultValue: '100',
              }),
            },
            {
              title: 'sdate',
              required: '',
              type: 'String',
              desc: apiParamDesc({ title: '검색시작일', sub: '(YYYY-MM-DD)' }),
            },
            {
              title: 'edate',
              required: '',
              type: 'String',
              desc: apiParamDesc({ title: '검색종료일', sub: '(YYYY-MM-DD)' }),
            },
            {
              title: 'opt_yn',
              required: '',
              type: 'Boolean',
              desc: apiParamDesc({
                title: '옵션 사용여부',
                sub: '["Y: 옵션이 있는 상품만 조회", "N": 옵션이 없는 상품만 조회"]',
                notes: ['<code>값을 넣지않는경우 전체검색됩니다.</code>'],
              }),
            }
          ],
          body_example: {
            shop_cd: "A001",
            shop_id: "myshopy3",
            start: 0,
            length: 100,
            sdate: '2020-07-20',
            edate: '2022-12-31',
            opt_yn: '',
          },
          response: [
            {
              title: 'results',
              required: 'O',
              type: 'Array',
              desc: '검색결과는 수집 상품 번호로 그룹화되어 배열로 출력됩니다.',
            },
            {
              title: 'sol_no',
              required: 'O',
              type: 'Number(8)',
              desc: '솔루션번호',
              indent: 1,
            },
            {
              title: 'import_ol_shop_no',
              required: 'O',
              type: 'Number(10)',
              desc: '수집 상품 번호',
              indent: 1,
            },
            {
              title: 'shop_cd',
              required: 'O',
              type: 'String(4)',
              desc: '쇼핑몰 코드',
              indent: 1,
            },
            {
              title: 'shop_id',
              required: 'O',
              type: 'String(40)',
              desc: '쇼핑몰 계정 아이디',
              indent: 1,
            },
            {
              title: 'shop_sale_no',
              required: 'O',
              type: 'String(40)',
              desc: '쇼핑몰 판매번호',
              indent: 1,
            },
            {
              title: 'shop_sale_no_sub',
              required: 'O',
              type: 'Number(80)',
              desc: apiParamDesc({ title: '쇼핑몰 판매 번호(쇼핑몰상품코드 서브)', defaultValue: 'null' }),
              indent: 1,
            },
            {
              title: 'sale_no',
              required: 'O',
              type: 'Number(11)',
              desc: apiParamDesc({ title: '마스터상품 고유번호', notes: ['해당 번호가 같은 온라인상품은 동일 마스터상품에 묶여있습니다.'] }),
              indent: 1,
            },
            {
              title: 'c_sale_cd',
              required: 'O',
              type: 'String(40)',
              desc: '판매자관리코드',
              indent: 1,
            },
            {
              title: 'shop_c_sale_cd',
              required: 'O',
              type: 'String(40)',
              desc: '쇼핑몰판매자 관리코드',
              indent: 1,
            },
            {
              title: 'std_ol_yn',
              required: 'O',
              type: 'Number(1)',
              desc: apiParamDesc({ title: '단일상품 여부', sub: '(0: 일반상품, 1: 단일상품)', defaultValue: 'null' }),
              indent: 1,
            },
            {
              title: 'group_info',
              required: 'O',
              type: 'String',
              desc: '그룹 정보',
              indent: 1,
            },
            {
              title: 'wdate',
              required: 'O',
              type: 'String(19)',
              desc: apiParamDesc({ title: '수집 상품 등록일', sub: '(YYYY-MM-DD HH:mm:ss)' }),
              indent: 1,
            },
            {
              title: 'shop_sale_name',
              required: 'O',
              type: 'String(200)',
              desc: '쇼핑몰상품명',
              indent: 1,
            },
            {
              title: 'shop_promotion_name',
              required: 'O',
              type: 'String(100)',
              desc: '상품 프로모션명',
              indent: 1,
            },
            {
              title: 'shop_cate_no',
              required: 'O',
              type: 'Number(8)',
              desc: '쇼핑몰 카테고리 번호',
              indent: 1,
            },
            {
              title: 'shop_cate_no_add_info',
              required: 'O',
              type: 'Object',
              desc: '쇼핑몰 카테고리 추가 정보',
              indent: 1,
            },
            {
              title: 'sale_stime',
              required: 'O',
              type: 'String(19)',
              desc: apiParamDesc({ title: '판매 시작일', sub: '(YYYY-MM-DD HH:mm:ss)', defaultValue: 'null' }),
              indent: 1,
            },
            {
              title: 'sale_etime',
              required: 'O',
              type: 'String(19)',
              desc: apiParamDesc({ title: '판매 종료일', sub: '(YYYY-MM-DD HH:mm:ss)', defaultValue: 'null' }),
              indent: 1,
            },
            {
              title: 'gift_name',
              required: 'O',
              type: 'String',
              desc: '사은품',
              indent: 1,
            },
            {
              title: 'opt_sort1',
              required: 'O',
              type: 'String(80)',
              desc: '옵션구분 1',
              indent: 1,
            },
            {
              title: 'opt_sort2',
              required: 'O',
              type: 'String(80)',
              desc: '옵션구분 2',
              indent: 1,
            },
            {
              title: 'opt_sort3',
              required: 'O',
              type: 'String(80)',
              desc: '옵션구분 3',
              indent: 1,
            },
            {
              title: 'opt_sort1_desc',
              required: 'O',
              type: 'String',
              desc: '옵션값1',
              indent: 1,
            },
            {
              title: 'opt_sort2_desc',
              required: 'O',
              type: 'String',
              desc: '옵션값2',
              indent: 1,
            },
            {
              title: 'opt_sort3_desc',
              required: 'O',
              type: 'String',
              desc: '옵션값3',
              indent: 1,
            },
            {
              title: 'opt_sort1_cd',
              required: 'O',
              type: 'String(10)',
              desc: '옵션구분코드 1',
              indent: 1,
            },
            {
              title: 'opt_sort2_cd',
              required: 'O',
              type: 'String(10)',
              desc: '옵션구분코드 2',
              indent: 1,
            },
            {
              title: 'opt_sort3_cd',
              required: 'O',
              type: 'String(10)',
              desc: '옵션구분코드 3',
              indent: 1,
            },
            {
              title: 'detail_desc',
              required: 'O',
              type: 'String(16777215)',
              desc: '상품 상세설명',
              indent: 1,
            },
            {
              title: 'keyword',
              required: 'O',
              type: 'String',
              desc: '키워드',
              indent: 1,
            },
            {
              title: 'tax_type',
              required: 'O',
              type: 'String',
              desc: apiParamDesc({ title: '과세여부', allowedValues: ['과세', '면세', '영세', '비과세'] }),
              indent: 1,
            },
            {
              title: 'madein_no',
              required: 'O',
              type: 'Number',
              desc: apiParamDesc({ title: '원산지번호', sub: '(원산지 조회 api 호출하여 확인)' }),
              indent: 1,
            },
            {
              title: 'madein_etc',
              required: 'O',
              type: 'String(30)',
              desc: apiParamDesc({ title: '기타원산지', defaultValue: 'null' }),
              indent: 1,
            },
            {
              title: 'multi_madein_yn',
              required: 'O',
              type: 'Number(1)',
              desc: apiParamDesc({ title: '복수원산지여부', sub: '(1: 복수원산지, 0: 복수원산지 아님)', defaultValue: '0' }),
              indent: 1,
            },
            {
              title: 'model',
              required: 'O',
              type: 'String(40)',
              desc: '모델명',
              indent: 1,
            },
            {
              title: 'brand',
              required: 'O',
              type: 'String(40)',
              desc: '브랜드',
              indent: 1,
            },
            {
              title: 'maker',
              required: 'O',
              type: 'String(40)',
              desc: '제조사',
              indent: 1,
            },
            {
              title: 'barcode',
              required: 'O',
              type: 'String(50)',
              desc: '바코드',
              indent: 1,
            },
            {
              title: 'sale_price',
              required: 'O',
              type: 'Number(12)',
              desc: '상품 금액',
              indent: 1,
            },
            {
              title: 'supply_price',
              required: 'O',
              type: 'Number(12)',
              desc: apiParamDesc({ title: '공급가', defaultValue: '0' }),
              indent: 1,
            },
            {
              title: 'cost_price',
              required: 'O',
              type: 'Number(12)',
              desc: apiParamDesc({ title: '상품 원가', defaultValue: '0' }),
              indent: 1,
            },
            {
              title: 'street_price',
              required: 'O',
              type: 'Number(12)',
              desc: apiParamDesc({ title: '시중가', defaultValue: '0' }),
              indent: 1,
            },
            {
              title: 'ship_price_type',
              required: 'O',
              type: 'String',
              desc: apiParamDesc({ title: '배송비 종류', allowedValues: ['무료', '조건부무료', '착불', '선결제'] }),
              indent: 1,
            },
            {
              title: 'ship_price',
              required: 'O',
              type: 'Number(8)',
              desc: '배송비 금액',
              indent: 1,
            },
            {
              title: 'sale_cnt_limit',
              required: 'O',
              type: 'Number(10)',
              desc: '판매수량',
              indent: 1,
            },
            {
              title: 'sale_img1',
              required: 'O',
              type: 'String(200)',
              desc: '기본이미지',
              indent: 1,
            },
            {
              title: 'sale_img2',
              required: 'O',
               type: 'String(200)',
              desc: '추가이미지 1',
              indent: 1,
            },
            {
              title: 'sale_img3',
              required: 'O',
               type: 'String(200)',
              desc: '추가이미지 2',
              indent: 1,
            },
            {
              title: 'sale_img4',
              required: 'O',
               type: 'String(200)',
              desc: '추가이미지 3',
              indent: 1,
            },
            {
              title: 'sale_img5',
              required: 'O',
               type: 'String(200)',
              desc: '추가이미지 4',
              indent: 1,
            },
            {
              title: 'sale_img6',
              required: 'O',
               type: 'String(200)',
              desc: '추가이미지 5',
              indent: 1,
            },
            {
              title: 'sale_img7',
              required: 'O',
               type: 'String(200)',
              desc: '추가이미지 6',
              indent: 1,
            },
            {
              title: 'sale_img8',
              required: 'O',
               type: 'String(200)',
              desc: '추가이미지 7',
              indent: 1,
            },
            {
              title: 'sale_img9',
              required: 'O',
               type: 'String(200)',
              desc: '추가이미지 8',
              indent: 1,
            },
            {
              title: 'sale_img10',
              required: 'O',
               type: 'String(200)',
              desc: '추가이미지 9',
              indent: 1,
            },
            {
              title: 'sale_img11',
              required: 'O',
               type: 'String(200)',
              desc: '추가이미지 10',
              indent: 1,
            },
            {
              title: 'opt_type',
              required: 'O',
              type: 'String',
              desc: apiParamDesc({ title: '옵션 타입', allowedValues: ['옵션없음', '조합형', '독립형', '간편옵션'] }),
              indent: 1,
            },
            {
              title: 'use_addopt_yn',
              required: 'O',
              type: 'Number(1)',
              desc: apiParamDesc({
                title: '추가구매옵션 여부',
                sub: '(1: 추가구매옵션 사용, 0: 추가구매옵션 사용안함)',
                defaultValue: '0',
              }),
              indent: 1,
            },
            {
              title: 'input_opt_name',
              required: 'O',
              type: 'String',
              desc: '입력형옵션',
              indent: 1,
            },
            {
              title: 'cert_type',
              required: 'O',
              type: 'String',
              desc: apiParamDesc({ title: '인증정보타입', allowedValues: ['인증유형등록', '인증대상아님', '상세설명내등록'] }),
              indent: 1,
            },
            {
              title: 'isbn',
              required: 'O',
              type: 'Number(13)',
              desc: apiParamDesc({ title: 'isbn 번호', defaultValue: 'null' }),
              indent: 1,
            },
            {
              title: 'prod_noti_data',
              required: 'O',
              type: 'Object',
              desc: apiParamDesc({ title: '상품정보제공고시', sub: '상품분류코드에 따라 infoDetail 안에 키 값이 달라질 수 있습니다.' }),
              indent: 1,
            },
            {
              title: 'made_date',
              required: 'O',
              type: 'String(19)',
              desc: apiParamDesc({ title: '생산일 일자', sub: '(YYYY-MM-DD HH:mm:ss)' }),
              indent: 1,
            },
            {
              title: 'expire_date',
              required: 'O',
              type: 'String(19)',
              desc: apiParamDesc({ title: '유통 기한', sub: '(YYYY-MM-DD HH:mm:ss)' }),
              indent: 1,
            },
            {
              title: 'map_yn',
              required: 'O',
              type: 'Number(1)',
              desc: '매핑 여부',
              indent: 1,
            },
            {
              title: 'foreign_ship_avail_yn',
              required: 'O',
              type: 'Number(1)',
              desc: '해외 배송 가능 여부',
              indent: 1,
            },
            {
              title: 'adult_yn',
              required: 'O',
              type: 'Number(1)',
              desc: apiParamDesc({ title: '성인전용 여부', sub: '(1: 성인용품, 0: 성인용품 아님)' }),
              indent: 1,
            },
            {
              title: 'prod_weight',
              required: 'O',
              type: 'Number(1)',
              desc: '대표 상품 상품 무게',
              indent: 1,
            },
            {
              title: 'detail_desc_ad',
              required: 'O',
              type: 'String',
              desc: '상세설명_광고홍보',
              indent: 1,
            },
            {
              title: 'detail_desc_add',
              required: 'O',
              type: 'String',
              desc: '상세설명_추가',
              indent: 1,
            },
            {
              title: 'detail_desc_eng',
              required: 'O',
              type: 'String',
              desc: '상세설명_영어',
              indent: 1,
            },
            {
              title: 'detail_desc_chn',
              required: 'O',
              type: 'String',
              desc: '상세설명_중국어',
              indent: 1,
            },
            {
              title: 'detail_desc_jpn',
              required: 'O',
              type: 'String',
              desc: '상세설명_일본어',
              indent: 1,
            },

            {
              title: 'cardview_img',
              required: 'O',
              type: 'String(200)',
              desc: '카드뷰 이미지',
              indent: 1,
            },
            {
              title: 'mobile_img',
              required: 'O',
              type: 'String(200)',
              desc: '모바일 이미지',
              indent: 1,
            },
            {
              title: 'mobile_detail_img',
              required: 'O',
              type: 'String(200)',
              desc: '모바일 상세 이미지',
              indent: 1,
            },

            {
              title: 'list_img',
              required: 'O',
              type: 'String(200)',
              desc: '리스트 이미지',
              indent: 1,
            },
            {
              title: 'width_img',
              required: 'O',
              type: 'String(200)',
              desc: '가로 이미지',
              indent: 1,
            },
            {
              title: 'exists_prod_img',
              required: 'O',
              type: 'String(200)',
              desc: '실제제품 이미지',
              indent: 1,
            },
            {
              title: 'expand_img1',
              required: 'O',
              type: 'String(200)',
              desc: '확대 이미지1',
              indent: 1,
            },
            {
              title: 'expand_img2',
              required: 'O',
              type: 'String(200)',
              desc: '확대 이미지2',
              indent: 1,
            },
            {
              title: 'thumbnail_img',
              required: 'O',
              type: 'String(200)',
              desc: '썸네일 이미지',
              indent: 1,
            },
            {
              title: 'worklog_job_id',
              required: 'O',
              type: 'Number',
              desc: '작업번호',
              indent: 1,
            },
            {
              title: 'set_info',
              required: 'O',
              type: 'Object',
              desc: apiParamDesc({ title: '쇼핑몰 정보(세트정보)', defaultValue: 'null' }),
              indent: 1,
            },
            {
              title: 'prod_noti_data1',
              required: 'O',
              type: 'Object',
              desc: apiParamDesc({ title: '상품 정보 고시1', defaultValue: '' }),
              indent: 1,
            },
            {
              title: 'prod_noti_data2',
              required: 'O',
              type: 'Object',
              desc: apiParamDesc({ title: '상품 정보 고시2(상품고시1 실패시 사용)', defaultValue: 'null' }),
              indent: 1,
            },
            {
              title: 'prod_noti_data3',
              required: 'O',
              type: 'Object',
              desc: apiParamDesc({ title: '상품 정보 고시3(상품고시2 실패시 사용)', defaultValue: 'null' }),
              indent: 1,
            },
            {
              title: 'nextday_ship_ol_yn',
              required: 'O',
              type: 'Number(1)',
              desc: '내일배송 상품 여부',
              indent: 1,
            },
            {
              title: 'nextday_ship_avail_yn',
              required: 'O',
              type: 'Number(1)',
              desc: '내일배송 상품 여부',
              indent: 1,
            },
            {
              title: 'prod_cate',
              required: 'O',
              type: 'Array',
              desc: '수집상품 카테고리',
              indent: 1,
            },
            {
              title: 'import_cate_no',
              required: '',
              type: 'Number',
              desc: '수집상품 카테고리 번호',
              indent: 2,
            },
            {
              title: 'shop_cate_name',
              required: '',
              type: 'String(100)',
              desc: '쇼핑몰 카테고리명',
              indent: 2,
            },
            {
              title: 'shop_cate_cd',
              required: '',
              type: 'String(100)',
              desc: '쇼핑몰 카테고리 코드',
              indent: 2,
            },
            {
              title: 'shop_cate_show_yn',
              required: '',
              type: 'Number(1)',
              desc: '쇼핑몰 전시 카테고리 여부',
              indent: 2,
            },
            {
              title: 'map_yn',
              required: '',
              type: 'Number(1)',
              desc: '매핑 여부',
              indent: 2,
            },
            {
              title: 'sol_cate_no',
              required: '',
              type: 'Number',
              desc: '솔루션 카테고리 번호',
              indent: 2,
            },
            {
              title: 'sol_cate_shop_add_info',
              required: '',
              type: 'Object',
              desc: apiParamDesc({ title: '솔루션쇼핑몰 카테고리 추가 정보', defaultValue: '' }),
              indent: 2,
            },
            {
              title: 'prod_cert',
              required: 'O',
              type: 'Array',
              desc: '수집상품 인증정보',
              indent: 1,
            },
            {
              title: 'import_ol_shop_cert_seq',
              required: '',
              type: 'Number(1)',
              desc: '가져오기 온라인상품 인증 순번',
              indent: 2,
            },
            {
              title: 'wdate',
              required: '',
              type: 'String(19)',
              desc: apiParamDesc({ title: '수집 상품 인증 정보 쓰기시각', sub: '(YYYY-MM-DD HH:mm:ss)' }),
              indent: 2,
            },
            {
              title: 'cert_exc_type',
              required: '',
              type: 'String',
              desc: apiParamDesc({
                title: '인증 면제 유형',
                allowedValues: ['kc_01', 'kc_02', 'kc_03', 'kc_04'],
                notes: ['kc_01: 안전기준준수대상', 'kc_02: 구매대행', 'kc_03: 병행수입', 'kc_04: 사용안함'],
              }),
              indent: 2,
            },
            {
              title: 'shop_cert_no',
              required: '',
              type: 'String(7)',
              desc: '인증 코드',
              indent: 2,
            },
            {
              title: 'cert_cd',
              required: '',
              type: 'String(7)',
              desc: '인증 코드',
              indent: 2,
            },
            {
              title: 'cert_ministry',
              required: '',
              type: 'String(30)',
              desc: '인증기관',
              indent: 2,
            },
            {
              title: 'cert_no',
              required: '',
              type: 'String(40)',
              desc: '인증 번호',
              indent: 2,
            },
            {
              title: 'cert_model',
              required: '',
              type: 'String(70)',
              desc: '인증 모델',
              indent: 2,
            },
            {
              title: 'cert_cname',
              required: '',
              type: 'String(30)',
              desc: '인증 업체명',
              indent: 2,
            },
            {
              title: 'cert_date',
              required: '',
              type: 'String(19)',
              desc: apiParamDesc({ title: '인증 일자', sub: '(YYYY-MM-DD HH:mm:ss)' }),
              indent: 2,
            },
            {
              title: 'cert_expire_date',
              required: '',
              type: 'String(19)',
              desc: apiParamDesc({ title: '인증 만료일', sub: '(YYYY-MM-DD HH:mm:ss)' }),
              indent: 2,
            },
            {
              title: 'prod_opt',
              required: 'O',
              type: 'Array',
              desc: '수집상품 옵션정보',
              indent: 1,
            },
            {
              title: 'import_prod_no',
              required: '',
              type: 'Number',
              desc: '수집 상품의 상품 번호',
              indent: 2,
            },
            {
              title: 'deal_type',
              required: '',
              type: 'String',
              desc: apiParamDesc({ title: '옵션타입', allowedValues: ['기초상품', '추가구매'] }),
              indent: 2,
            },
            {
              title: 'opt_status',
              required: '',
              type: 'String',
              desc: apiParamDesc({ title: '옵션상태', allowedValues: ['정상', '품절'] }),
              indent: 2,
            },
            {
              title: 'opt_name1',
              required: '',
              type: 'String(80)',
              desc: apiParamDesc({ title: '옵션값1', defaultValue: 'null' }),
              indent: 2,
            },
            {
              title: 'opt_name2',
              required: '',
              type: 'String(80)',
              desc: apiParamDesc({ title: '옵션값2', defaultValue: 'null' }),
              indent: 2,
            },
            {
              title: 'opt_name3',
              required: '',
              type: 'String(80)',
              desc: apiParamDesc({ title: '옵션값3', defaultValue: 'null' }),
              indent: 2,
            },
            {
              title: 'opt_name1_cd',
              required: '',
              type: 'String(10)',
              desc: '옵션구분코드 1',
              indent: 2,
            },
            {
              title: 'opt_name2_cd',
              required: '',
              type: 'String(10)',
              desc: '옵션구분코드 2',
              indent: 2,
            },
            {
              title: 'opt_name3_cd',
              required: '',
              type: 'String(10)',
              desc: '옵션구분코드 3',
              indent: 2,
            },
            {
              title: 'add_item_name',
              required: '',
              type: 'String(50)',
              desc: '추구구매옵션명',
              indent: 2,
            },
            {
              title: 'add_item_opt_name',
              required: '',
              type: 'String(50)',
              desc: '추구구매옵션값',
              indent: 2,
            },
            {
              title: 'shop_sale_name',
              required: '',
              type: 'String(200)',
              desc: '쇼핑몰상품명',
              indent: 2,
            },
            {
              title: 'prod_img',
              required: '',
              type: 'String(200)',
              desc: '상품 이미지',
              indent: 2,
            },
            {
              title: 'madein_etc',
              required: '',
              type: 'String(30)',
              desc: apiParamDesc({ title: '기타원산지', defaultValue: 'null' }),
              indent: 2,
            },
            {
              title: 'multi_madein_yn',
              required: '',
              type: 'Number(1)',
              desc: apiParamDesc({ title: '복수원산지여부', sub: '(1: 복수원산지, 0: 복수원산지 아님)', defaultValue: '0' }),
              indent: 2,
            },
            {
              title: 'maker',
              required: '',
              type: 'String(40)',
              desc: '제조사',
              indent: 2,
            },
            {
              title: 'brand',
              required: '',
              type: 'String(40)',
              desc: '브랜드',
              indent: 2,
            },
            {
              title: 'model',
              required: '',
              type: 'String(40)',
              desc: '모델명',
              indent: 2,
            },
            {
              title: 'opt_price',
              required: '',
              type: 'Number',
              desc: '옵션 판매가',
              indent: 2,
            },
            {
              title: 'sale_opt_cnt_limit',
              required: '',
              type: 'Number',
              desc: '옵션 판매최대수량',
              indent: 2,
            },
            {
              title: 'set_no',
              required: '',
              type: 'Number',
              desc: apiParamDesc({
                title: '옵션에 매칭된 세트상품 고유 번호',
                sub: '(재고관리 미사용시 미노출)',
                defaultValue: 'null',
                notes: ['세트 상품 번호는 옵션 순번에 따라 출력됩니다.', '세트 상품 번호가 존재할 경우 sale_opt_seq로 옵션을 구분해주세요.'],
              }),
              indent: 2,
            },
            {
              title: 'prod_no',
              required: '',
              type: 'Number',
              desc: apiParamDesc({
                title: '옵션에 매칭된 sku 상품 고유번호',
                sub: '(재고관리 미사용시 미노출)',
                defaultValue: 'null',
              }),
              indent: 2,
            },
            {
              title: 'shop_sku_cd',
              required: '',
              type: 'String(40)',
              desc: '쇼핑몰에서 수집된 sku_cd',
              indent: 2,
            },
            {
              title: 'save_type',
              required: '',
              type: 'String',
              desc: apiParamDesc({ title: '저장방식', sub: '(상품정보:prod,직접입력:direct)', defaultValue: 'prod' }),
              indent: 2,
            },
            {
              title: 'sku_cd',
              required: '',
              type: 'String(40)',
              desc: apiParamDesc({ title: '옵션에 매칭된 SKU상품 sku코드', sub: '(재고관리 미사용시 미노출)' }),
              indent: 2,
            },
            {
              title: 'prod_name',
              required: '',
              type: 'String(80)',
              desc: apiParamDesc({ title: '옵션에 매칭된 SKU상품명', sub: '(재고관리 미사용시 미노출)' }),
              indent: 2,
            },
            {
              title: 'opt_sale_cd',
              required: '',
              type: 'String(40)',
              desc: '옵션 상품 코드',
              indent: 2,
            },
            {
              title: 'contents',
              required: '',
              type: 'String',
              desc: '상품 상세설명',
              indent: 2,
            },
            {
              title: 'tax_type',
              required: '',
              type: 'String',
              desc: apiParamDesc({ title: '과세여부', allowedValues: ['과세', '면세', '영세', '비과세'] }),
              indent: 2,
            },
            {
              title: 'madein_no',
              required: '',
              type: 'Number',
              desc: apiParamDesc({ title: '원산지번호', sub: '(원산지 조회 api 호출하여 확인)' }),
              indent: 2,
            },
            {
              title: 'sale_price',
              required: '',
              type: 'Number(10)',
              desc: '상품 금액',
              indent: 2,
            },
            {
              title: 'stock_cnt_real',
              required: '',
              type: 'Number',
              desc: '실재고',
              indent: 2,
            },
            {
              title: 'depot_no',
              required: '',
              type: 'Number',
              desc: '배송처 코드',
              indent: 2,
            },
            {
              title: 'pack_unit',
              required: '',
              type: 'Number',
              desc: apiParamDesc({ title: '옵션에 매칭된 SKU상품 출고수량', sub: '(재고관리 미사용시 미노출)' }),
              indent: 2,
            },
            {
              title: 'map_yn',
              required: '',
              type: 'Number(1)',
              desc: '매핑 여부',
              indent: 2,
            },
          ],
          response_example: {
            "results": [
              {
                "import_ol_shop_no": 23204583,
                "sol_no": 640,
                "shop_cd": "A001",
                "shop_id": "myshopy3",
                "shop_sale_no": "D380097342",
                "shop_sale_no_sub": "4743703363",
                "sale_no": null,
                "c_sale_cd": "",
                "shop_c_sale_cd": "790606",
                "std_ol_yn": 0,
                "group_info": "",
                "wdate": "2023-05-30 19:37:42",
                "shop_sale_name": "야구 모자",
                "shop_promotion_name": "",
                "shop_cate_no": null,
                "shop_cate_no_add_info": null,
                "sale_stime": "0001-01-01 00:00:00",
                "sale_etime": "0001-01-01 00:00:00",
                "gift_name": "",
                "opt_sort1": "모자",
                "opt_sort2": "",
                "opt_sort3": "",
                "opt_sort1_desc": "블랙,화이트",
                "opt_sort2_desc": "",
                "opt_sort3_desc": "",
                "opt_sort1_cd": "",
                "opt_sort2_cd": "",
                "opt_sort3_cd": null,
                "detail_desc": "멋있는 모자~ \r\n\r\n\r\n\r\nhttps://img.freepik.com/free-psd/isolated-black-and-white-front-caps_125540-2539.jpg?q=10&h=200",
                "keyword": "",
                "tax_type": "과세",
                "madein_no": null,
                "madein_etc": "국내=서울=강서구",
                "multi_madein_yn": 0,
                "model": "",
                "brand": "",
                "maker": "",
                "barcode": null,
                "sale_price": 7500,
                "supply_price": 0,
                "cost_price": 0,
                "street_price": 0,
                "ship_price_type": "선결제",
                "ship_price": 2500,
                "sale_cnt_limit": 99999,
                "sale_img1": "http://image.auction.co.kr/itemimage/32/75/50/327550b996.jpg",
                "sale_img2": "",
                "sale_img3": "",
                "sale_img4": "",
                "sale_img5": "",
                "sale_img6": "",
                "sale_img7": "",
                "sale_img8": "",
                "sale_img9": "",
                "sale_img10": "",
                "sale_img11": "",
                "opt_type": "독립형",
                "use_addopt_yn": 0,
                "input_opt_name": "",
                "cert_type": "인증대상아님",
                "isbn": 0,
                "prod_noti_data": {
                  "infoCode": "FashionItems2023",
                  "infoName": "패션잡화(모자/벨트/액세서리 등)",
                  "infoDetail": {
                    "size": "66",
                    "type": "모자/캡",
                    "caution": "없음",
                    "made_in": "한국",
                    "material": "천",
                    "warranty": "?",
                    "manufacturer": "집",
                    "customer_service": "010-9"
                  }
                },
                "made_date": "0001-01-01",
                "expire_date": "0001-01-01",
                "map_yn": 0,
                "foreign_ship_avail_yn": 0,
                "adult_yn": 0,
                "prod_weight": null,
                "detail_desc_ad": null,
                "detail_desc_add": null,
                "detail_desc_eng": null,
                "detail_desc_chn": null,
                "detail_desc_jpn": null,
                "cardview_img": "",
                "mobile_img": "",
                "mobile_detail_img": "",
                "list_img": "",
                "width_img": "",
                "exists_prod_img": "",
                "expand_img1": "",
                "expand_img2": "",
                "thumbnail_img": "",
                "worklog_job_id": null,
                "set_info": null,
                "prod_noti_data1": null,
                "prod_noti_data2": null,
                "prod_noti_data3": null,
                "nextday_ship_ol_yn": null,
                "nextday_ship_avail_yn": null,
                "prod_cate": [
                  {
                    "import_cate_no": 23549233,
                    "shop_cate_name": "가방/잡화 > 모자 > 스냅백/힙합모자",
                    "shop_cate_cd": "16_59_14_00",
                    "shop_cate_show_yn": 0,
                    "map_yn": 0,
                    "sol_cate_no": null,
                    "sol_cate_shop_add_info": "{\"catecode_esm\":\"00110003000100000000\"}"
                  }
                ],
                "prod_cert": [
                  {
                    "import_ol_shop_cert_seq": 1,
                    "wdate": "2023-06-14 14:30:11",
                    "cert_exc_type": "kc_01",
                    "shop_cert_no": "cert_14",
                    "cert_cd": "cert_24",
                    "cert_ministry": "한국식품안전관리인증원장",
                    "cert_no": "2021-3-1596",
                    "cert_model": null,
                    "cert_cname": null,
                    "cert_date": null,
                    "cert_expire_date": null
                  }
                ],
                "prod_opt": [
                  {
                    "import_prod_no": 117388690,
                    "deal_type": "기초상품",
                    "opt_status": "정상",
                    "opt_name1": "모자",
                    "opt_name2": "블랙",
                    "opt_name3": "",
                    "opt_name1_cd": "0",
                    "opt_name2_cd": "0",
                    "opt_name3_cd": null,
                    "add_item_name": "",
                    "add_item_opt_name": "",
                    "shop_sale_name": "야구 모자",
                    "prod_img": "http://image.auction.co.kr/itemimage/32/75/50/327550b996.jpg",
                    "madein_etc": "국내=서울=강서구",
                    "multi_madein_yn": 0,
                    "maker": "",
                    "brand": "",
                    "model": "",
                    "opt_price": 0,
                    "sale_opt_cnt_limit": 99999,
                    "set_no": null,
                    "prod_no": null,
                    "shop_sku_cd": null,
                    "save_type": "prod",
                    "sku_cd": null,
                    "prod_name": null,
                    "opt_sale_cd": null,
                    "contents": null,
                    "tax_type": "과세",
                    "madein_no": null,
                    "sale_price": null,
                    "stock_cnt_real": null,
                    "depot_no": null,
                    "pack_unit": 1,
                    "map_yn": 0
                  },
                  {
                    "import_prod_no": 117388691,
                    "deal_type": "기초상품",
                    "opt_status": "정상",
                    "opt_name1": "모자",
                    "opt_name2": "화이트",
                    "opt_name3": "",
                    "opt_name1_cd": "0",
                    "opt_name2_cd": "0",
                    "opt_name3_cd": null,
                    "add_item_name": "",
                    "add_item_opt_name": "",
                    "shop_sale_name": "야구 모자",
                    "prod_img": "http://image.auction.co.kr/itemimage/32/75/50/327550b996.jpg",
                    "madein_etc": "국내=서울=강서구",
                    "multi_madein_yn": 0,
                    "maker": "",
                    "brand": "",
                    "model": "",
                    "opt_price": 0,
                    "sale_opt_cnt_limit": 99999,
                    "set_no": null,
                    "prod_no": null,
                    "shop_sku_cd": null,
                    "save_type": "prod",
                    "sku_cd": null,
                    "prod_name": null,
                    "opt_sale_cd": null,
                    "contents": null,
                    "tax_type": "과세",
                    "madein_no": null,
                    "sale_price": null,
                    "stock_cnt_real": null,
                    "depot_no": null,
                    "pack_unit": 1,
                    "map_yn": 0
                  }
                ]
              }
            ]
          },
        },
      ],
    },
    {
      title: '수집 상품 삭제',
      url: '/doc/수집 상품 삭제',
      data: [
        {
          version: 'v1.0',
          url: '/product/online/listOfScrap',
          desc: apiDocDesc({ items: ['상품 수집 작업을 통해 수집한 상품을 삭제합니다.'] }),
          method: 'DELETE',
          header: default_header,
          header_example: default_header_example,
          body: [
            {
              title: 'import_ol_shop_no_list',
              required: 'O',
              type: 'Number[]',
              desc: '수집 상품 번호 리스트',
            },
          ],
          body_example: {
            import_ol_shop_no_list: [12345, 12346]
          },
          response: [
            {
              title: 'results',
              required: 'O',
              type: 'String',
              desc: '성공, 실패여부',
            }
          ],
          response_example: {
            "results": 'success'
          },
        },
      ],
    },
  ];
};

export default getV10APIs;